var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "page-main has-bottom" },
      [
        _c("page-title", { attrs: { back: true }, on: { goback: _vm.goback } }),
        _vm._v(" "),
        _c(
          "page-card",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticStyle: { "margin-bottom": "32px" },
          },
          [
            _c("template", { slot: "header" }, [_vm._v(" Well Information ")]),
            _vm._v(" "),
            _c(
              "div",
              { attrs: { slot: "body" }, slot: "body" },
              [
                _c("wellComp", {
                  attrs: { "page-data": _vm.pageData, "well-index": 1 },
                }),
              ],
              1
            ),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }